import { connect } from 'react-redux';
import { defineMessages } from 'react-intl';
import { createSelector } from 'reselect';
import { setModel } from '../../../../../store/bulk/update/bulk.update.actions';
import { BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID } from '../../../../../store/orders/drawer/constants';

import Global from '../../../../../store/global-selectors';
import { selectBulkUpdateBulkUpdateJob } from '../../../../../store/bulk/update/bulk.update.selectors';
import { isShipFromExternal } from '../../../../../store/csw/csw.fulfillment-plan-to-csw';

import { ShipFromDropdown } from './index';

const messages = defineMessages({
  shipFrom: {
    description: 'csw.shipFrom',
    defaultMessage: 'Ship From',
    id: 'WeMvog',
  },
  returnTo: {
    description: 'csw.returnTo',
    defaultMessage: 'Return To',
    id: 'BznHDu',
  },
});

const shipFromsSelector = createSelector(
  (sellerShipFroms) => sellerShipFroms,
  (_, sellerFulfillmentProviders) => sellerFulfillmentProviders,
  (sellerShipFroms, sellerFulfillmentProviders) => sellerFulfillmentProviders.concat(sellerShipFroms),
);

const mapStateToProps = (state, props) => {
  const {
    selectedShipFromId,
    onShipFromSelected,
    className,
    togglerClassName,
    dropdownMenuShouldHaveWidthOfButton,
    required,
    fulfillmentPlanId,
    hasError,
    bulkUpdateJobId: bulkUpdateJobIdFromProps,
  } = props;
  const bulkUpdateJobId = bulkUpdateJobIdFromProps || BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID;
  const { model } = selectBulkUpdateBulkUpdateJob(state, {
    bulkUpdateJobId,
  });
  const sellerShipFroms = Global.selectSellerShipFroms(state);
  const sellerFulfillmentProviders = Global.selectSellerActiveFulfillmentProviders(state);
  const shipFroms = shipFromsSelector(sellerShipFroms, sellerFulfillmentProviders);
  const labelTranslation = messages.shipFrom;
  const verifiedShipFromId = shipFroms.find((shipFrom) => shipFrom.shipFromId === selectedShipFromId)
    ? selectedShipFromId
    : Global.selectSellerDefaultShipFromId(state);
  const { name: selectedTitle } = shipFroms.find((shipFrom) => shipFrom.shipFromId === verifiedShipFromId) ?? {};
  const isExternalShipFrom = selectedShipFromId && isShipFromExternal(selectedShipFromId);

  return {
    bulkUpdateJobId,
    className,
    dropdownMenuShouldHaveWidthOfButton,
    fulfillmentPlanId,
    hasError,
    isExternalShipFrom,
    labelTranslation,
    model,
    onShipFromSelected,
    required,
    selectedShipFromId: verifiedShipFromId,
    selectedTitle,
    shipFroms,
    togglerClassName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setModel: (bulkUpdateJobId, newModel) => dispatch(setModel(bulkUpdateJobId, newModel)),
  };
};

export const ShipFromDropdownContainer = connect(mapStateToProps, mapDispatchToProps)(ShipFromDropdown);
